import { SkeletonContainer } from './style'

export const Skeleton = ({ minW, w, h, m }) => {
  return <SkeletonContainer  minWidth={minW} width={w} height={h} margin={m} />
}
